import React from 'react';
import SocialLink from "./SocialLink";


const Footer = () => (
    <div className="footer">
        <div className="footer__bottom text-center">
            <i className="icon icon--brand-logo" />&nbsp;
            &copy; {DJ_CONST.currentYear} Novastar - All rights reserved
            <div className="social--links">
                <SocialLink url={DJ_CONST.SOCIAL_LINKS.facebook} type="facebook" />
                <SocialLink url={DJ_CONST.SOCIAL_LINKS.twitter} type="twitter" />
                <SocialLink url={DJ_CONST.SOCIAL_LINKS.instagram} type="instagram" />
            </div>
        </div>
    </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js